import ActionTypes from 'core/actions/actionTypes';
import initialState from 'core/reducers/initialState';
import { iDef } from 'core/util/TypeUtils';

/**
 * @overview: Reducers to designate panels and views active and inactive on the
 * site. This is used by the {@link EditorWrapper} to dispay a list of items available
 * to edit. Unused when the current user does not have edit permission.
 *
 * @author: jesposito
 */

export default function layoutReducer(state = initialState.active, action: any) {
	switch (action.type) {

		case ActionTypes.ACTIVE_PANEL_ADD:

			if(state.panels.includes(action.panel)) {
				return state;
			}

			// use a set to ensure there are no duplicates
			return {...state, panels: [...new Set([...state.panels, action.panel])]};

		case ActionTypes.ACTIVE_PANEL_REMOVE:

			return {...state, panels: state.panels.filter((p) => p !== action.panel)};

		case ActionTypes.ACTIVE_VIEW_ADD:

			if(iDef(state.views[action.panelInstance]) && iDef(state.views[action.panelInstance][action.viewKey])) {
				return state;
			}

			return {...state, views: {...state.views, [action.panelInstance]: {...state.views[action.panelInstance], [action.viewKey]: action.viewId}}};

		case ActionTypes.ACTIVE_VIEW_REMOVE:

			return {...state, panels: state.views.filter((v) => v !== action.view)};

		case ActionTypes.SET_GLOBAL_PANEL_STATE:

			return { ... state, panelState: {...state.panelState, [action.panelInstance]: action.state}};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/core/reducers/activeReducer.ts